import React from 'react';
import PropTypes from 'prop-types';
import s from './breadcrumb.module.css';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-closing-tag-location */

export const SimpleReturnsBreadcrumb = ({ step, handleStepClick }) => (
  <div className={s.breadcrumb_image_container}>
    <svg
      id="breadcrumb_svg"
      width="200"
      height="40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 200 40"
      style={{ enableBackground: 'new 0 0 200 40' }}
      xmlSpace="preserve"
    >
      <g className="breadcrumb-fill">
        <rect x="87.5" y="20" width="2" height="2" />
        <rect x="95.5" y="20" width="2" height="2" />
        <rect x="79.5" y="20" width="2" height="2" />
        <rect x="75.5" y="20" width="2" height="2" />
        <rect x="83.5" y="20" width="2" height="2" />
        <rect x="99.5" y="20" width="2" height="2" />
        <rect x="91.5" y="20" width="2" height="2" />
        <rect x="119.5" y="20" width="2" height="2" />
        <rect x="123.5" y="20" width="2" height="2" />
        <rect x="111.5" y="20" width="2" height="2" />
        <rect x="107.5" y="20" width="2" height="2" />
        <rect x="115.5" y="20" width="2" height="2" />
        <rect x="103.5" y="20" width="2" height="2" />
        <path d="M66.5,14c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5c3.1,0,5.6-2.1,6.3-5h0.7v-2H73C72.7,16.6,69.9,14,66.5,14z" />
        <path d="M134.5,14c-3.4,0-6.2,2.6-6.5,6h-0.5v2h0.7c0.7,2.9,3.2,5,6.3,5c3.6,0,6.5-2.9,6.5-6.5S138.1,14,134.5,14z M134.5,25c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5S137,25,134.5,25z" />
      </g>
    </svg>
    <div className={s.breadcrumb_link_container}>
      <a
        className={`${s.breadcrumb_link} ${step > 1 ? s.breadcrumb_link_active : ''}`}
        onClick={(e) => handleStepClick(1, e)}
        href="#"
        aria-label={`Redirect to step 1 ${step < 1 ? ' (Inactive)' : ''}`}
        role="button"
        disabled={step <= 1}
      ></a>
      <a
        className={s.breadcrumb_link}
        href="#"
        onClick={(e) => handleStepClick(false, e)}
        disabled
        role="button"
      ></a>
      <div className="clearfix" />
    </div>
  </div>
);

SimpleReturnsBreadcrumb.propTypes = {
  step: PropTypes.number.isRequired,
  handleStepClick: PropTypes.func.isRequired,
};
